module.exports = __webpack_public_path__ + "img/002.d5be7359.png";